"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composition_api_1 = require("@vue/composition-api");
var scroller_javascript_1 = require("../../mobiscroll/js/scroller.javascript");
var componentName = 'wok-mobile-picker-time';
exports.default = composition_api_1.defineComponent({
    name: componentName,
    props: {
        value: {
            type: String,
            default: '00:00'
        },
        delta: {
            type: Number,
            default: 5
        },
        pickerLabel: {
            type: String,
            default: ''
        },
        cancelLabel: {
            type: String,
            default: 'Cancel'
        },
        confirmLabel: {
            type: String,
            default: 'Confirm'
        }
    },
    setup: function (props, context) {
        var scroller = composition_api_1.ref();
        function parseValue(value) {
            if (value) {
                var parts = value.split(':');
                return [parseInt(parts[0]), parseInt(parts[1])];
            }
            return [0, 0];
        }
        var hours = new Array(), minutes = new Array();
        for (var i = 0; i < 24; i++) {
            hours.push(i.toString().padStart(2, '0'));
        }
        for (var i = 0; i < 60; i += props.delta) {
            minutes.push(i.toString().padStart(2, '0'));
        }
        var lastSelectedValue = props.value;
        var scrollerInstance = null;
        composition_api_1.onMounted(function () {
            scrollerInstance = scroller_javascript_1.default.scroller(scroller.value, {
                display: 'inline',
                showLabel: false,
                wheels: [
                    [{
                            circular: false,
                            data: hours
                        }, {
                            circular: false,
                            data: minutes
                        }]
                ],
                formatValue: function (data) {
                    return data[0].toString().padStart(2, '0') + ':' + data[1].toString().padStart(2, '0');
                },
                parseValue: function (valueText) {
                    return parseValue(valueText);
                },
                onChange: function (evt) {
                    lastSelectedValue = evt.valueText;
                }
            });
            scrollerInstance.setVal(parseValue(props.value));
        });
        composition_api_1.watch(function () { return props.value; }, function (val) {
            scrollerInstance === null || scrollerInstance === void 0 ? void 0 : scrollerInstance.setVal(parseValue(val));
        });
        var onConfirm = function () {
            context.emit('input', lastSelectedValue);
        };
        var onRequestHidePicker = function () {
            context.emit('hide-picker');
        };
        return {
            scroller: scroller,
            onConfirm: onConfirm,
            onRequestHidePicker: onRequestHidePicker
        };
    }
});
